import React, { useEffect, useRef } from 'react';
import $ from "jquery";

const GuideMessageStatus = () => {

    const firstFocusRef = useRef(null);

    useEffect(() => {
        const modalEl = document.getElementById("MsgGuideModal");
        if (!modalEl) return;
        const onShown = () => setTimeout(() => firstFocusRef.current?.focus(), 50);
        modalEl.addEventListener("shown.bs.modal", onShown);
        return () => modalEl.removeEventListener("shown.bs.modal", onShown);
    }, []);

    const CloseModal = () => {
        if (document.activeElement instanceof HTMLElement) {
            document.activeElement.blur();
        }
        $('#MsgGuideModal').modal('hide');
    };

    return (
    <div className="GuideMessageStatus">
        <div 
            className="modal fade" 
            id="MsgGuideModal" 
            data-backdrop="static"  
            tabIndex="-1" 
            role="dialog" 
            aria-labelledby="message-status-guide-title"
            aria-describedby="messageStatusGuideDesc"
            aria-modal="true"
        >
            <div className="modal-dialog">
                <div className="modal-content">
                    <div className="modal-header">
                        <h2 className="modal-title spacer-inline" id="message-status-guide-title">Message Status Guide</h2>
                            <button
                                type="button"
                                className="close"
                                aria-label="Close message status guide"
                                onClick={CloseModal}
                            >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <div className="modal-content-body">
                            <p 
                                id="messageStatusGuideDesc"
                                className="descript-container"
                                ref={firstFocusRef}
                                tabIndex="-1"
                            >
                                Message status page shows status of the sent messages, whether they were successfully sent or failed and provides additional information about the successful delivery or reasons for failure.
                            </p>
                            <div className="sp-pad8">
                                <dl>
                                    <dt>Date Sent:</dt>
                                    <dd className="descript-container">Date and time when message was sent.</dd><br />
                                    <dt>Sent To:</dt>
                                    <dd className="descript-container">Destination Direct email address. Note that the same message could have been sent to multiple TO/CC addresses, but since the status could be different for each destination address, each TO address has separate line in the message status report.
                                    </dd><br />
                                    <dt>Message Type:</dt>
                                    <dd className="descript-container">If message is MDN or not an MDN</dd><br />
                                    <dt>Status:</dt>
                                    <dd className="descript-container">Confirmed, Failed, Success, or Accepted</dd><br />
                                    <dt>Extended Status:</dt>
                                    <dd className="descript-container">
                                        If the message was successfully delivered to the destination email server, extended status will contain IP address of the server and return code (success is indicated by the SMTP code 250).
                                    </dd>
                                    <dt>Date/Time Accepted:</dt>
                                    <dd className="descript-container">
                                        In Direct protocol, guaranteed message delivery is ensured by the use of MDNs - message disposition notifications. One such MDN must be sent by the receiving HISP once the message is received, validated and accepted for delivery to the recipient. Once our HISP receives such MDN, the date/time when it was sent is logged as the date/time accepted. This type of MDN is called MDN:processed and it is mandatory according to the Direct specification, receiving HISP must send it for each successfully received message.
                                    </dd>
                                    <dt>Date/Time Confirmed:</dt>
                                    <dd className="descript-container">
                                        Second MDN, so called MDN:dispatched may be sent by the receiving HISP - it is optional. When it is sent, it typically indicates that message was indeed delivered to the intended recipient. Note that not all HISPs send it. When our HISP receives MDN:dispatched, it is logged as date/time confirmed.
                                    </dd>
                                    <dt>Message ID:</dt>
                                    <dd className="descript-container">
                                        Unique ID assigned to the message by the sender. ID is required by email standards and by Direct protocol, it can be useful if further troubleshooting is required, otherwise it can be ignored. This is included in the download report files.
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button 
                            type="button" 
                            className="btn btn-outline-secondary" 
                            onClick={CloseModal}
                        >
                            Close
                        </button>
                    </div>
                </div>
            </div>
          </div>
        </div>
    )
};


export default GuideMessageStatus;
